import BubbleServices from "./BubbleServices";
import HttpServices from "./HttpServices";

const DEFAULT_BUBBLE_PREFERENCE = "default_bubble_id";

const BUBBLES_ON_PREFERENCE = "bubbles_on";
const BREAKDOWNS_ON_PREFERENCE = "breakdowns_on";
const CONFETTI_ON_PREFERENCE = "confetti_on";
const DYNAMIC_TITLE_BAR_ON_PREFERENCE = "dynamic_titlebar_on";



export default {

    settings: {},

    DEFAULT_BUBBLE_PREFERENCE: DEFAULT_BUBBLE_PREFERENCE,
    BUBBLES_ON_PREFERENCE: BUBBLES_ON_PREFERENCE,
    BREAKDOWNS_ON_PREFERENCE: BREAKDOWNS_ON_PREFERENCE,
    CONFETTI_ON_PREFERENCE: CONFETTI_ON_PREFERENCE,
    DYNAMIC_TITLE_BAR_ON_PREFERENCE: DYNAMIC_TITLE_BAR_ON_PREFERENCE,

    saveUserToLocalStorage(user) {
        localStorage.user = JSON.stringify(user);
    },

    saveTokenToLocalStorage(token) {
        localStorage.token = token;
    },

    loadUserFromLocalStorage() {
        if (!localStorage.user) {
            return null;
        }

        return JSON.parse(localStorage.user);
    },

    async login(email, password) {
        if (email && password) {
            const res = await HttpServices.post(`/user/login`, {
                email: email,
                password: password
            });

            this.saveUserToLocalStorage(res.user);
            this.saveTokenToLocalStorage(res.token);

            return res;

        } else {
            throw Error("Please enter your email and password");
        }
    },

    getPreference(key) {
        if (this.settings[key]) {
            return this.settings[key];
        }

        return null;
    },

    async savePreference(key, value) {
        var updatedSettings = JSON.parse(JSON.stringify(this.settings));
        updatedSettings[key] = value;
        
        const refreshedSettings = await HttpServices.patch(`/user/settings`, {
            settings: updatedSettings
        });

        this.settings = refreshedSettings;
        return refreshedSettings;
    },

    async loadUserData() {
        if (this.userData) {
            return this.userData;
        }

        var userData = {
            subscribed: false,
            bubbles: []
        };

        // Check for active subscriptions
        const activeSubscriptions = await HttpServices.get(`/subscription`);

        if (activeSubscriptions.length > 0) {
            userData.subscribed = true;
        }

        // Now load bubbles
        const taskBubbles = await BubbleServices.listBubbles();
        userData.bubbles = taskBubbles;

        return userData;
    },

    async register(email, password) {
        if (email && password) {
            const result = await HttpServices.post(`/user/register`, {
                email: email,
                password: password
            });

            this.saveUserToLocalStorage(result.user);
            this.saveTokenToLocalStorage(result.token);

            return result;

        } else {
            throw Error("Please enter your email and password");
        }
    },

    async loadUserSettings() {
        const settings = await HttpServices.get(`/user/settings`);
        this.settings = settings;
        return settings;
    }
};


// WEBPACK FOOTER //
// ./src/services/UserServices.js